import { createPortal } from "react-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "./button";

interface CompletionModalProps {
  message: string;
  onEnregistrer: () => void;
  isLoading?: boolean;
}

export function CompletionModal({ message, onEnregistrer, isLoading = false }: CompletionModalProps) {
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-voile/40 backdrop-blur-sm p-4">
      <div
        className="relative w-full max-w-md rounded-surface bg-card shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-8 py-10 text-center space-y-6">
          <div className="flex justify-center">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-etat-fait-surface">
              <CheckCircle className="h-10 w-10 text-etat-fait" />
            </div>
          </div>

          <div className="space-y-2">
            <h2 className="text-xl font-semibold text-foreground">
              Évaluation terminée
            </h2>
            <p className="text-sm text-muted-foreground leading-relaxed">{message}</p>
          </div>

          <Button
            onClick={onEnregistrer}
            disabled={isLoading}
            className="w-full"
          >
            {isLoading ? "Enregistrement..." : "Enregistrer"}
          </Button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
